import { HttpClient } from '@angular/common/http';
import { Component, computed, DestroyRef } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, ValidatorFn, Validators } from '@angular/forms';
import { ImageCroppedEvent, ImageCropperComponent } from 'ngx-image-cropper';
import { GlobalConstants } from 'src/app/common/global';
import { environment } from 'src/environments/environment';
import { filter, forkJoin, map, of, Subscription, switchMap } from 'rxjs';
import { OibCheckerService } from 'src/app/services/oib-checker-service';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { ProfileService } from 'src/app/services/profile.service';
import { membershipTypes } from 'src/app/common/constants';
import { MembershipService } from '../membership.service';
import { CommonModule } from '@angular/common';
import { RegistrationMembershipComponent } from 'src/app/components/registration-membership/registration-membership.component';
import { TranslateModule } from '@ngx-translate/core';
import { ErrorMessageService } from 'src/app/services/error-message.util';
import { AppConfigService } from 'src/app/common/app-config/app-config.service';
import { NgxMaskDirective } from 'ngx-mask';
import { ModalNames } from 'src/app/common/modal.config';
import { ModalService } from 'src/app/services/modal.service';
import { GetUserProfileService } from 'src/app/services/getUserProfile.service';
import { PaymentComponent } from 'src/app/components/payment/payment.component';
import { CartInfoBoxComponent } from 'src/app/components/cart-info-box/cart-info-box.component';
import { Order, ProfileField } from 'src/app/common/event.model';
import { OrderService } from 'src/app/services/getOrder.service';
import { GdprConsentQuestion } from '../membership.model';
import { atLeastOneLetterValidator, dateValidator, minAgeValidator, oibValidator, pttConditionalValidator, strictEmailValidator } from 'src/app/utils/validators';
import { NavigationCartService } from 'src/app/components/navigation-cart/navigation.cart.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DeliveryComponent } from 'src/app/components/delivery/delivery.component';
import { FormDataStoreService } from 'src/app/services/form-data.store';

interface MembershipInfo {
  transId: number
  membershipId: number;
}

@Component({
  selector: 'app-buy-membership',
  templateUrl: `./${environment.pageFolder}/buy-membership.${environment.pageFolder}.component.html`,
  styleUrls: [`./${environment.pageFolder}/buy-membership.${environment.pageFolder}.component.sass`],
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, RegistrationMembershipComponent, ImageCropperComponent, TranslateModule, NgxMaskDirective, PaymentComponent, CartInfoBoxComponent, DeliveryComponent, RouterLink]
})

export class BuyMembershipComponent {
  private subscription: Subscription = new Subscription();
  userProfileTypeList: ProfileField[] = [];
  editableFields: ProfileField[] = [];

  private readonly formDataKey = `${ModalNames.Membership}`;
  userProfileForm!: FormGroup;

  imageChangedEvent: any;
  croppedImage: any;
  acceptImageTerms: boolean = false;
  loader = document.getElementById("loader-container");
  errorMessage: string = "";
  membershipHolderForm: FormGroup;
  termsOfSaleForm: FormGroup;
  inputDate: string = "";
  errorMessageDatebirth: string = "";
  errorMessageOib: string = "";
  errorMessagePbr: string = "";
  errorMessagePdf: string = "";
  errorMessageGender: string = "";
  errorMessageTermsOfSale: string = "";
  membershipInfo!: MembershipInfo;
  gpdrConsentQuestions: GdprConsentQuestion[] = [];
  showApplicationFormContainer: boolean = false;
  hasMembership: boolean = false;
  acceptCommunicationWithClubTerms: boolean = false;
  isUserLoggedIn: boolean = GlobalConstants.isAuth;
  autoRenewalMembership: boolean = false;
  hideHolderForm: boolean = false;
  membershipTypes = membershipTypes;
  profileType: string = (this.route.snapshot.queryParams['type'] === "club-friend") ? membershipTypes.CLUB_FRIEND : membershipTypes.FULL_FLEDGED;
  isListLoaded: boolean = false;
  appConfig: any;
  showPaymentOnModalForMembership: boolean = false;
  showDeliveryOnModalForMembership: boolean = false;
  orderId: number = 0;
  order: any;
  customerProfile: any;
  redirectUrl = environment.redirectUrl;
  public readonly modalNamesEnum = ModalNames;
  readonly isMembershipModalOpen = computed(() => this.modalService.modalsState().get(ModalNames.Membership) ?? false);
  userProfileName: string = "";
  userProfileSurname: string = "";
  prefillObject: any;

  constructor(
    private formBuilder: FormBuilder,
    private http: HttpClient,
    private oibCheckerService: OibCheckerService,
    private route: ActivatedRoute,
    private router: Router,
    private profileService: ProfileService,
    private membershipService: MembershipService,
    private appConfigService: AppConfigService,
    public modalService: ModalService,
    private readonly errorMessageService: ErrorMessageService,
    private getUserProfileService: GetUserProfileService,
    private orderService: OrderService,
    private readonly destroyRef: DestroyRef,
    private navigationCartService: NavigationCartService,
    private readonly formDataStore: FormDataStoreService
  ) {
    this.appConfig = this.appConfigService.getConfig();

    if(this.profileType === membershipTypes.CLUB_FRIEND) {
      this.hideHolderForm = true;
    } else if(this.appConfig.appHasMembership) {
      this.getMemberships();
    }

    this.membershipHolderForm = formBuilder.group({
      membershipHolder : ['', Validators.required]
    });

    this.termsOfSaleForm = formBuilder.group({
      termsOfSale: [false, Validators.requiredTrue]
    });

    if(this.appConfig.appHasMembership) {
      this.getProfilesTypes();
    }

    sessionStorage.removeItem("openPage");
  }

  ngOnInit() {
    if(environment.configId === "4") {
      const lastOrder$ = this.navigationCartService.getLastOrder();

      if(this.navigationCartService.lastOrder !== 0) {
        this.orderId = this.navigationCartService.lastOrder;

        this.orderService.getOrder(this.orderId).subscribe((order: Order) => {
          this.order = order;

          if(this.order?.transactionInfo?.deliveryDataSubmitted && order.items.length === 0) {
            this.showPaymentOnModalForMembership = true;
            this.showDeliveryOnModalForMembership = false;
          } else if(order.items.length === 0) {
            this.showDeliveryOnModalForMembership = true;
          }
        });
      } else if (lastOrder$ && typeof lastOrder$.pipe === 'function') {
        lastOrder$
        .pipe(
          takeUntilDestroyed(this.destroyRef),
          filter(response => response.data != null),
          switchMap(response => this.orderService.getOrder(response.data))
        )
        .subscribe({
          next: (order) => {
            if (!order.transactionInfo.ticketDelagation && order.items.length === 0) {
              this.order = order;

              if(this.order?.transactionInfo?.deliveryDataSubmitted) {
                this.showPaymentOnModalForMembership = true;
                this.showDeliveryOnModalForMembership = false;
              } else {
                this.showDeliveryOnModalForMembership = true;
              }

              this.orderId = order.id;
            }
          }
        });
      }
    }
  }

  getMemberships() {
    this.loader!.style.display = "flex";
    this.subscription = this.profileService.getMemberships(true).subscribe({
      next: data => {
        const response: any = data;
        const membership = response.data.own;
        this.hasMembership = response.data.own !== null &&
        ((membership.approved && membership.isActive) || (membership.approved && !membership.isActive && membership.isRenewable) || (!membership.approved)) &&
        ((membership.isActive && !membership.isRenewable) || (membership.isActive && membership.isRenewable) || (!membership.isActive && !membership.isRenewable) || (!membership.isActive && membership.isRenewable));

        let membershipHolderFromSessionStorage = sessionStorage.getItem("membershipHolder");

        setTimeout(() => {
          let membershipHolderInputOwn:any = document.getElementById("16004721");
          let membershipHolderInputOther:any = document.getElementById("16004722");

          if(membershipHolderFromSessionStorage) {
            if(membershipHolderFromSessionStorage === "own" && !this.hasMembership && this.hasMembership !== undefined) {
              membershipHolderInputOwn.checked = true;
              this.membershipHolderForm.value.membershipHolder = "me";
            } else if(membershipHolderFromSessionStorage === "others") {
              this.membershipHolderForm.value.membershipHolder = "other";
              membershipHolderInputOther.checked = true;
            }
          }
        }, 200);

        this.isListLoaded = true;
        this.loader!.style.display = "none";
      }
    });
  }

  getProfilesTypes() {
    this.loader!.style.display = "flex";

    if (environment.configId === "4") {
      const form$ = this.membershipService.getMembershipForm(this.profileType);

      const fieldMapping: Record<string, string> = {
        email: 'email',
        firstName: 'ime',
        lastName: 'prezime',
        address: 'adresa',
        houseNo: 'kucni_broj',
        city: 'mjesto',
        postNo: 'pbr',
        country: 'drzava',
        phoneNo: 'tel'
      };

      form$.subscribe({
        next: (form) => {
          this.userProfileTypeList = form.data.profile.fields;
          this.gpdrConsentQuestions = form.data.gdprConsent.questions;

          const prefill = new Map<string, string>();

          this.userProfileTypeList.forEach(field => {
            if (field.value) {
              prefill.set(field.name, field.value);
            }
          });

          for (const [userProfileKey, formFieldKey] of Object.entries(fieldMapping)) {
            const matchingField = this.userProfileTypeList.find(field => field.name === formFieldKey);
            if (matchingField && matchingField.value) {
              prefill.set(formFieldKey, matchingField.value);
            }
          }

          if (prefill.has('ime')) {
            this.userProfileName = prefill.get('ime') || '';
          }
          if (prefill.has('prezime')) {
            this.userProfileSurname = prefill.get('prezime') || '';
          }

          this.editableFields = this.userProfileTypeList.filter(field =>
            field.name === 'pbr' || !prefill.has(field.name) || !field.value
          );

          const isOwnHolder = sessionStorage.getItem('membershipHolder') === 'own' && !this.hasMembership;

          const controls: Record<string, FormControl> = {};
          for (const item of this.editableFields) {
            if(!item.visible) {
              continue;
            }

            let initial: string;
            const prefillValue = prefill.get(item.name);
            if (prefillValue !== undefined && prefillValue !== null) {
              initial = prefillValue;
            } else if (item.value) {
              initial = item.value;
            } else if (item.name === 'drzava_lov') {
              initial = 'HR';
            } else if (isOwnHolder) {
              initial = item.value ?? '';
            } else {
              initial = '';
            }

            const validators: ValidatorFn[] = item.name === 'drzava_lov' ? []
              : [
                ...(item.mandatory ? [Validators.required] : []),
                ...(item.length ? [Validators.maxLength(item.length)] : []),
                ...(item.name === 'email' ? [strictEmailValidator] : []),
                ...(item.name === 'oib' ? [oibValidator] : []),
                ...(item.name === 'dat_rodj' ? [dateValidator, minAgeValidator(16)] : []),
                ...(item.name === 'ime' || item.name === 'prezime' ? [atLeastOneLetterValidator()] : []),
              ];

            const control = new FormControl({ value: initial, disabled: false }, { validators, nonNullable: false });
            Object.assign(control, { type: item.type.toLowerCase(), id: item.id, name: item.name });
            controls[item.name] = control;
          }

          const groupValidators: ValidatorFn[] = [];
          if (this.editableFields.some(f => f.name === 'pbr')) {
            groupValidators.push(pttConditionalValidator());
          }

          this.userProfileForm = new FormGroup(controls, { validators: groupValidators });
          this.prefillObject = Object.fromEntries(prefill);

          const combinedForm = new FormGroup({ profile: this.userProfileForm, termsOfSale: this.termsOfSaleForm });
          this.formDataStore.subscribeToForm(this.formDataKey, combinedForm, this.destroyRef);

          this.membershipRegistrationData();
          this.loader!.style.display = 'none';
        },
        error: () => {
          this.loader!.style.display = 'none';
          this.errorMessage = this.errorMessageService.getErrorMessage('error');
        }
      });
    } else {
      this.membershipService.getMembershipForm(this.profileType).subscribe({
        next: (response) => {
          this.userProfileTypeList = response.data.profile.fields;
          this.gpdrConsentQuestions = response.data.gdprConsent.questions;

          let fields: any = {};

          this.userProfileTypeList.forEach((item) => {
            fields[item.name] = new FormControl(item.name);
            fields[item.name].type = item.type.toLowerCase();
            fields[item.name].id = item.id;

            if (sessionStorage.getItem("membershipHolder") === "own" && (!this.hasMembership && this.hasMembership !== undefined)) {
              fields[item.name].value = item.value;
            } else {
              fields[item.name].value = "";
            }

            item.name === "drzava_lov" && (fields[item.name].value = "HR");
            fields[item.name].name = item.name;
          });

          this.userProfileForm = new FormGroup(fields);

          this.membershipRegistrationData();
          this.loader!.style.display = 'none';
        },
        error: () => {
          this.loader!.style.display = 'none';
          this.errorMessage = this.errorMessageService.getErrorMessage('error');
        },
      });
    }
  }

  membershipRegistrationData(): void {
    let membershipDataFromRegistration = sessionStorage.getItem("memberRegisterData");
    if (membershipDataFromRegistration) {
      let membershipDataParsed = JSON.parse(membershipDataFromRegistration);
      this.userProfileForm.patchValue(membershipDataParsed);
      sessionStorage.removeItem("memberRegisterData");
    }
  }

  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
  }

  removeImage() {
    this.imageChangedEvent = "";
    this.croppedImage = "";
  }

  toggleImageTerms() {
    this.acceptImageTerms = !this.acceptImageTerms;
    this.imageChangedEvent = "";
    this.croppedImage = "";
  }

  onSubmit() {
    let validationError = false;

    if(environment.configId === "4") {
      this.membershipHolderForm.value.membershipHolder = "me";
      this.userProfileForm.markAllAsTouched();
      this.termsOfSaleForm.markAllAsTouched();
      this.errorMessageTermsOfSale = '';
      this.errorMessage = '';

      if (!this.termsOfSaleForm.value.termsOfSale) {
        validationError = true;
        this.errorMessageTermsOfSale = this.errorMessageService.getErrorMessage("termsOfSaleRequired");
      } else if (this.userProfileForm.invalid) {
        validationError = true;
        const controls = Object.values(this.userProfileForm.controls);

        if (controls.some(c => c.hasError('required'))) {
          this.errorMessage = this.errorMessageService.getErrorMessage("allFieldsRequired");
        }
        else if (controls.some(c => c.hasError('invalidDate'))) {
          this.errorMessage = this.errorMessageService.getErrorMessage("invalidDate");
        }
        else if (controls.some(c => c.hasError('futureDate'))) {
          this.errorMessage = this.errorMessageService.getErrorMessage("dateInFuture");
        }
        else if (controls.some(c => c.hasError('tooYoung'))) {
          this.errorMessage = this.errorMessageService.getErrorMessage("membershipInvalidBirthDateMsg");
        }
        else if (controls.some(c => c.hasError('invalidOib'))) {
          this.errorMessage = this.errorMessageService.getErrorMessage("invalidOIB");
        }
        else if (this.userProfileForm.hasError('invalidPTT')) {
          this.errorMessage = this.errorMessageService.getErrorMessage("postalCodeDigits");
        }
        else if (controls.some(c => c.hasError('invalidEmail'))) {
          this.errorMessage = this.errorMessageService.getErrorMessage("invalidEmail");
        }
        else if (controls.some(c => c.hasError('noLetter'))) {
          this.errorMessage = this.errorMessageService.getErrorMessage("noLetters");
        }
        else {
          this.errorMessage = this.errorMessageService.getErrorMessage("error");
        }
      }
    } else {
      validationError = this.userFormValidation();
    }

    sessionStorage.removeItem("acceptTerms");

    if(validationError === false) {
      let imageDataBase, imageDataBaseName;

      if(this.croppedImage) {
        imageDataBase = this.croppedImage.split("data:image/png;base64,")[1];
        imageDataBaseName = "Naziv slike";
      } else {
        imageDataBase  = "";
        imageDataBaseName = "";
      }

      if(!this.acceptCommunicationWithClubTerms) {
        this.userProfileForm.value.email= "";
        this.userProfileForm.value.tel = "";
      }

      let gdprAnswers = document.querySelectorAll("[data-name='gdpr-answer']");
      let gdprAnswersArray = Array.from(gdprAnswers);
      let gdprAnwsersChecked = "";

      gdprAnswersArray.forEach((checkbox:any) => {
        if (checkbox.checked) {
          gdprAnwsersChecked += `${checkbox.id},`;
        }
      });

      const editedValues = this.userProfileForm.value as Record<string, any>;
      const allFieldValues: Record<string,string> = {};

      for (const key in this.prefillObject) {
        if (Object.hasOwnProperty.call(this.prefillObject, key)) {
          if (!this.userProfileTypeList.some(field => field.name === key)) {
            delete this.prefillObject[key];
          }
        }
      }
      Object.assign(allFieldValues, this.prefillObject);

      for (const fieldDefault of this.userProfileTypeList) {
        const name = fieldDefault.name;
        const value = editedValues[name];

        if (value !== undefined && value !== '') {
          allFieldValues[name] = value;
        }
      }

      allFieldValues['drzava'] && (allFieldValues['drzava_lov'] = allFieldValues['drzava']);
      delete allFieldValues['drzava'];

      this.trimFormData();
      const membershipType = this.profileType === membershipTypes.FULL_FLEDGED ? "V1" : "V4";

      let body: any = JSON.stringify({
        'profileType': this.profileType,
        'membershipType': membershipType,
        'imageData': imageDataBase,
        'imageFilename': imageDataBaseName,
        'fields': allFieldValues,
        'autoRenewal': this.autoRenewalMembership,
        'gdprData': {
          'gdprTextId': environment.connId,
          'gdprAnswers': gdprAnwsersChecked
        },
      })

      sessionStorage.setItem("membershipData", JSON.stringify(this.userProfileForm.value));

      let endpoint = (this.membershipHolderForm.value.membershipHolder === "me" || this.profileType === membershipTypes.CLUB_FRIEND) ? "" : "/others";

      this.loader!.style.display = "flex";
      this.http.post(`${environment.apiUrl}/conn/${environment.connId}/v1/memberships/new${endpoint}`, body, GlobalConstants.headersCentral).subscribe({
        next: data => {
          let response:any = data;

          if(response.success === true) {
            this.errorMessage = "";
            this.membershipInfo = response.data;

            if(this.profileType === membershipTypes.CLUB_FRIEND || ((this.profileType === membershipTypes.FULL_FLEDGED && this.membershipHolderForm.value.membershipHolder === "me"))) {
              let profileTypeParams = (this.profileType === membershipTypes.CLUB_FRIEND) ? "club-friend" : "full-fledged";

              if(environment.configId === "4") {
                this.orderId = this.membershipInfo.transId;
                this.navigationCartService.lastOrder = this.membershipInfo.transId;

                this.orderService.getOrder(this.orderId).subscribe((order: Order) => {
                  this.order = order;
                })

                this.showDeliveryOnModalForMembership = true;
              } else {
                this.router.navigate(
                  [`/buy-membership/${this.membershipInfo.transId}`],
                  { queryParams: { type: profileTypeParams } }
                );
              }

            } else {
              this.showApplicationFormContainer = true;
            }
          } else if (response.success === false) {
            if(response.errors[0].message === "INVALID_ZIPCODE") {
              this.errorMessagePbr = this.errorMessageService.getErrorMessage("postalCodeNotFound");
            }

            this.membershipInfo = response.data;
          }

          this.formDataStore.clearFormData(this.formDataKey);
          this.loader!.style.display = "none";
        }, error: error => {
          if(error.status === 401) {
            //this.Services.logout();
            document.location = ``;
          } else if(error.error.errors[0].code === "ORA-20149") {
            this.errorMessage = this.errorMessageService.getErrorMessage("purchaseContinuationDisabled");
          } else if(error.error.errors[0].code === "ORA-20150") {
            this.errorMessage = this.errorMessageService.getErrorMessage("purchaseInProgress");
          } else if(error.error.errors[0].message === "INVALID_ZIPCODE") {
            this.errorMessagePbr = this.errorMessageService.getErrorMessage("postalCodeNotFound");
          } else {
            this.errorMessage = this.errorMessageService.getErrorMessage("error");
          }
          this.loader!.style.display = "none";
        }
      })
    }
  }

  trimFormData() {
    for (const key in this.userProfileForm.value) {
      if (Object.hasOwnProperty.call(this.userProfileForm.value, key)) {
        const value = this.userProfileForm.value[key];
        this.userProfileForm.value[key] = value.trim();
      }
    }
  }

  checkAdult() {
    this.errorMessage = "";

    this.inputDate = this.userProfileForm.value.dat_rodj;
    if (!this.inputDate) {
      return true;
    }

    let input:any = document.getElementById("dat_rodj");
    let inputCopy: any = input;
    if(inputCopy.nextElementSibling) {
      inputCopy.nextElementSibling.style.width = "100%";
      inputCopy.nextElementSibling.style.removeProperty("background-color", "#ed0000", "important");
    }
    input = input.value.split(".");
    const day = parseInt(input[0], 10);
    const month = parseInt(input[1], 10);
    const year = parseInt(input[2], 10);

    if (isNaN(day) || isNaN(month) || isNaN(year)) {
      return true;
    }

    const date = new Date(year, month - 1, day);
    const adultDate = new Date();
    adultDate.setFullYear(adultDate.getFullYear() - 18);

    if (inputCopy.value.length > 9 && date <= adultDate && this.membershipHolderForm.value.membershipHolder === "other") {
      inputCopy.nextElementSibling.style.width = "100%";
      inputCopy.nextElementSibling.style.setProperty("background-color", "#ed0000", "important");
      this.errorMessageDatebirth = this.errorMessageService.getErrorMessage("membershipBirthDateMsg");
      return true
    } else if(date >= adultDate && this.membershipHolderForm.value.membershipHolder === "me") {
      inputCopy.nextElementSibling.style.width = "100%";
      inputCopy.nextElementSibling.style.setProperty("background-color", "#ed0000", "important");
      this.errorMessageDatebirth = this.errorMessageService.getErrorMessage("membershipInvalidBirthDateMsg");
      return true
    } else {
      this.errorMessageDatebirth = "";
      return false
    }
  }

  checkOIB() {
    let input:any = document.getElementById("oib")!;
    input.nextElementSibling && input.nextElementSibling.style.removeProperty("background-color", "#ed0000", "important");
    const oib = input.value.toString();
    this.errorMessageOib = "";

    if (this.oibCheckerService.checkOIB(oib) === "valid") {
      this.errorMessageOib = "";
      return true;
    } else if(this.oibCheckerService.checkOIB(oib) === "invalid") {
      this.errorMessageOib = this.errorMessageService.getErrorMessage("invalidOIB");
      return false;
    } else {
      return false;
    }
  }

  removeErrorMessage(event:any) {
    event.nextElementSibling && event.nextElementSibling.style.removeProperty("background-color", "#ed0000", "important");
    this.errorMessage = "";
    this.errorMessagePbr = "";
  }

  downloadApplicationForm() {
    this.loader!.style.display = "flex";
    this.http.get<any>(`${environment.apiUrl}/conn/${environment.connId}/v1/memberships/applicationForm/${this.membershipInfo.membershipId}`, GlobalConstants.headersCentral).subscribe({
      next: data => {
        let response:any = data;
        let applicationForm = "data:application/pdf;base64," + response.data;
        const byteArray = new Uint8Array(atob(response.data).split('').map(char => char.charCodeAt(0)));
        let blob = new Blob([byteArray], {type: 'application/pdf'});
        let url = window.URL.createObjectURL(blob);
        const fileName = 'pristupnica.pdf';
        const downloadLink = document.createElement('a');

        downloadLink.href = url;
        downloadLink.download = fileName;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
        this.loader!.style.display = "none";
      },
      error: error => {
        this.errorMessage = this.errorMessageService.getErrorMessage('error');
        this.loader!.style.display = "none";
      }
    })
  }

  uploadApplicationForm(event:any) {
    let selectedFile = event.target.files[0];
    const reader = new FileReader();

    if(selectedFile.type === "application/pdf") {
      reader.onload = () => {
        let body = {
          document: reader.result?.toString().split("base64,")[1]
        }

        if (selectedFile.size > 6 * 1024 * 1024) {
          this.errorMessagePdf = this.errorMessageService.getErrorMessage("fileTooLarge");
          return;
        }

        this.http.post<any>(`${environment.apiUrl}/conn/${environment.connId}/v1/memberships/applicationForm/${this.membershipInfo.membershipId}`, body, GlobalConstants.headersCentral).subscribe({
          next: data => {
            let response:any = data;
            document.location = `buy-membership/${this.membershipInfo.transId}`;
          },
          error: error => {
            this.errorMessage = this.errorMessageService.getErrorMessage('error');
            this.loader!.style.display = "none";
          }
        })
      };

      reader.readAsDataURL(selectedFile);
    } else if(selectedFile.type.startsWith('image/')){
      reader.onloadend = () => {
        const base64String = reader.result as string;
        const image = new Image();
        image.src = base64String;
        image.onload = () => {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          const maxWidth = 1000;
          const maxHeight = 1000;
          let newWidth = image.width;
          let newHeight = image.height;

          if (newWidth > maxWidth || newHeight > maxHeight) {
            if (newWidth > newHeight) {
              newHeight = Math.round((newHeight * maxWidth) / newWidth);
              newWidth = maxWidth;
            } else {
              newWidth = Math.round((newWidth * maxHeight) / newHeight);
              newHeight = maxHeight;
            }
          }

          canvas.width = newWidth;
          canvas.height = newHeight;
          ctx!.drawImage(image, 0, 0, newWidth, newHeight);

          const compressedBase64 = canvas.toDataURL('image/jpeg', 0.9);

          let body = {
            document: compressedBase64.split("data:image/jpeg;base64,")[1]
          }

          this.http.post<any>(`${environment.apiUrl}/conn/${environment.connId}/v1/memberships/applicationForm/${this.membershipInfo.membershipId}`, body, GlobalConstants.headersCentral).subscribe({
            next: data => {
              let response:any = data;
              document.location = `buy-membership/${this.membershipInfo.transId}`;
            },
            error: error => {
              this.errorMessage = this.errorMessageService.getErrorMessage('error');
              this.loader!.style.display = "none";
            }
          })
        };
      };
    } else {
      alert("Greška pri učitavanju dokumenta")
    }

    reader.readAsDataURL(selectedFile);
  }

  userFormValidation() {
    let inputs:any = document.querySelectorAll('[data-name="user-data-membership"]');
    let termsOfSaleInput:any = document.getElementById("terms-of-sale");
    let olderThan18Input:any = document.getElementById("older-than-18");
    let validRepresentation:any = document.getElementById("16004733");
    let error:boolean = false;
    let membershipHolderFormOwn:any = document.getElementById("16004721");
    let membershipHolderFormOther:any = document.getElementById("16004722");

    this.checkAdult() && (error = true);

    let oibInput:any = document.getElementById("oib");

    if(oibInput && !this.checkOIB()) {
      oibInput.nextElementSibling.style.width = "100%";
      oibInput.nextElementSibling.style.setProperty("background-color", "#ed0000", "important");
      error = true;
      this.errorMessageOib = this.errorMessageService.getErrorMessage("invalidOIB");
    }

    if(this.profileType !== membershipTypes.CLUB_FRIEND && this.membershipHolderForm.value.membershipHolder === "") {
      error = true;
      membershipHolderFormOwn.nextElementSibling.classList.add("error-radio");
      membershipHolderFormOther.nextElementSibling.classList.add("error-radio");
      this.errorMessage = this.errorMessageService.getErrorMessage("chooseMembershipType");
    }

    inputs.forEach((item:any) => {
      if(item.id === "ptt" && item.value.length !== 5 && this.userProfileForm.value.drzava_lov === "HR") {
        item.nextElementSibling.style.width = "100%";
        item.nextElementSibling.style.setProperty("background-color", "#ed0000", "important");
        error = true;
        this.errorMessagePbr = this.errorMessageService.getErrorMessage("postalCodeDigits");
      }

      if(!item.value && item.id !== "oib") {
        item.nextElementSibling.style.width = "100%";
        item.nextElementSibling.style.backgroundColor = "#ed0000";
        error = true;
        this.errorMessage = this.errorMessageService.getErrorMessage("allFieldsRequired");
      }

      if(!this.userProfileForm.value.spol) {
        item.nextElementSibling.classList.add("error-radio");
        error = true;
        this.errorMessageGender = this.errorMessageService.getErrorMessage("requiredToChooseSex");
      }
    })

    let databirthInput:any = document.querySelectorAll("#dat_rodj");
    let currentDate = new Date();

    databirthInput.forEach((item:any) => {
      let datebirthCheck = /^(0?[1-9]|[12][0-9]|3[01])[.]((0?[1-9]|1[012])[.](19|20)?[0-9]{2})*$/;
      let elYears;

      if(item.value.length === 10) {
        elYears = item.value.substr(item.value.length - 4);
      }

      if(item.value.length > 0 && (!datebirthCheck.test(item.value) || item.value.length === 3 || (item.value.length > 5 && item.value.length != 10) || (item.value.length === 10 && elYears < 1922))) {
        item.nextElementSibling.classList.add("error");
        item.nextElementSibling.style.width = "100%";
        item.nextElementSibling.style.setProperty("background-color", "#ed0000", "important");
        error = true;
        this.errorMessage = this.errorMessageService.getErrorMessage("invalidDate");
      } else if(item.value.length > 0){
        let enteredDate = new Date(item.value.split('.').reverse().join('-'));
        if (enteredDate > currentDate) {
          item.nextElementSibling.classList.add("error");
          item.nextElementSibling.style.width = "100%";
          item.nextElementSibling.style.setProperty("background-color", "#ed0000", "important");
          error = true;
          this.errorMessage = this.errorMessageService.getErrorMessage("dateInFuture");
        } else {
          item.nextElementSibling && item.nextElementSibling.style.removeProperty("background-color", "#ed0000", "important");
        }
      }
    });

    if(olderThan18Input.id === "older-than-18" && !olderThan18Input.checked) {
      error = true;
      olderThan18Input.nextElementSibling.style.backgroundColor = "#ed0000";
      this.errorMessage = this.errorMessageService.getErrorMessage("requiredToAcceptAllFields");

    }

    if(validRepresentation?.id === "16004733" && !validRepresentation?.checked && this.membershipHolderForm.value.membershipHolder === "other") {
      error = true;
      validRepresentation.nextElementSibling.style.backgroundColor = "#ed0000";
      this.errorMessage = this.errorMessageService.getErrorMessage("requiredToAcceptAllFields");
    }

    if(termsOfSaleInput.id === "terms-of-sale" && !termsOfSaleInput.checked) {
      error = true;
      termsOfSaleInput.nextElementSibling.style.backgroundColor = "#ed0000";
      this.errorMessageTermsOfSale = this.errorMessageService.getErrorMessage("termsOfSaleRequired");
    }

    return error;
  }

  removeCountryErrorMessage() {
    this.errorMessage = "";
    let postNumberInput: any = document.getElementById("ptt");
    postNumberInput.nextElementSibling.style.removeProperty("background-color", "#ed0000", "important");
  }

  checkValue(event: any){
    if (environment.configId !== "4") {
      if(event.target.checked) {
        event.target.nextElementSibling.style.backgroundColor = "#012641c4";
        this.errorMessage = "";
        this.errorMessageTermsOfSale = "";
      } else {
        event.target.nextElementSibling.style.backgroundColor = "#e6e6e6";
      }
    }
  }

  checkDropdown(event: any) {
    if(event.target.value) {
      event.target.style.removeProperty("border", "2px solid #ed0000", "important");
    }
  }

  checkAutoRenewal(event: any) {
    this.autoRenewalMembership = event.target.checked;
  }

  checkMembershipHolder() {
    this.errorMessage = "";
    let membershipHolderFormOwn:any = document.getElementById("16004721");
    let membershipHolderFormOther:any = document.getElementById("16004722");
    sessionStorage.removeItem("membershipHolder")

    membershipHolderFormOwn.nextElementSibling.classList.remove("error-radio");
    membershipHolderFormOther.nextElementSibling.classList.remove("error-radio");
  }

  checkGenderCheckbox() {
    this.errorMessageGender = "";
    let genderCheckboxMale:any = document.getElementById("spol-M");
    let genderCheckboxFemale:any = document.getElementById("spol-F");

    genderCheckboxMale.nextElementSibling.classList.remove("error-radio");
    genderCheckboxFemale.nextElementSibling.classList.remove("error-radio");
  }

  toggleCommunicationWithClubTerms() {
    this.acceptCommunicationWithClubTerms = !this.acceptCommunicationWithClubTerms;
  }

  emitOnSubmitDeliveryData() {
    this.orderService.getOrder(this.orderId, true).subscribe({
      next: (order) => {
        this.order = order;
        this.showPaymentOnModalForMembership = true;
        this.showDeliveryOnModalForMembership = false;
      }
    });
  }

  onGoBackFromPayment() {
    this.showPaymentOnModalForMembership = false;
    this.showDeliveryOnModalForMembership = true;
  }

  goToUpdateProfilPage() {
    this.modalService.closeModal(ModalNames.Membership);
    this.router.navigate(['/update-profile']);
  }
}
